import { useLocation } from "react-router-dom";
import { ShoppingCart, ClipboardText, FileText, Receipt } from "@phosphor-icons/react";

const CONFIG = {
  "/procurement/requests": {
    title: "Purchase Requests",
    icon: ClipboardText,
    subtitle: "Raise, track and approve purchase requests before they become POs.",
  },
  "/procurement/quotations": {
    title: "Quotations",
    icon: FileText,
    subtitle: "Compare vendor quotations and pick the best option before ordering.",
  },
  "/procurement/orders": {
    title: "Purchase Orders",
    icon: Receipt,
    subtitle: "Manage approved purchase orders and their fulfilment.",
  },
};

export default function Procurement() {
  const loc = useLocation();
  const cfg = CONFIG[loc.pathname] || {
    title: "Procurement", icon: ShoppingCart,
    subtitle: "Procurement workflows.",
  };
  const Icon = cfg.icon;
  return (
    <div className="p-8 space-y-6" data-testid={`procurement-root-${loc.pathname.split("/").pop()}`}>
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">Procurement</div>
        <h1 className="font-heading text-4xl mt-1 tracking-tight">{cfg.title}</h1>
        <p className="text-sm text-zinc-500 mt-1">{cfg.subtitle}</p>
      </div>
      <div className="bg-white border border-zinc-200 p-12 text-center">
        <Icon size={40} className="mx-auto text-zinc-300 mb-4" />
        <p className="text-sm text-zinc-500">
          This module is coming soon. Purchase Requests, Quotations and Purchase Orders will connect
          to your existing Vendors, Expenses and Payments so nothing changes for finance downstream.
        </p>
        <p className="text-xs text-zinc-400 mt-3">Reach out to the admin if you need this module prioritised.</p>
      </div>
    </div>
  );
}
